import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=4a0e313a&scoped=true&"
import script from "./custom.vue?vue&type=script&lang=js&"
export * from "./custom.vue?vue&type=script&lang=js&"
import style0 from "./custom.vue?vue&type=style&index=0&id=4a0e313a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e313a",
  null
  
)

export default component.exports